// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles__checkboxWrapper___DL1CK","checkboxLabel":"styles__checkboxLabel___QzZlE","input":"styles__input___q8S7S"};